@if (fileUrls() | async; as fileUrls) {
  @for (url of fileUrls; track $index) {
    <a
      [href]="disabled() ? null : url"
      [class]="'d-flex align-items-center ' + andClass()"
      target="_blank"
      [class.disabled]="disabled()">
      <span class="flex-grow-1" [innerHtml]="label()"></span>
      <i class="fa fa-download" [hidden]="!includeIcon()"></i>
    </a>
  }
} @else {
  <a href [class]="'d-flex align-items-center disabled' + andClass()" target="_blank">
    <span class="flex-grow-1" [innerHtml]="label()"></span>
    <i class="fa fa-download" [hidden]="!includeIcon()"></i>
  </a>
}
